export default __webpack_public_path__ + "static/media/GaugeChartBlue.43631496.svg";